import { render, staticRenderFns } from "./ToggleItem.vue?vue&type=template&id=0d8fad09"
import script from "./ToggleItem.vue?vue&type=script&lang=js"
export * from "./ToggleItem.vue?vue&type=script&lang=js"
import style0 from "./ToggleItem.vue?vue&type=style&index=0&id=0d8fad09&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports